import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Environment
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.sceneGroup = this.experience.sceneGroup
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        
        // Debug
        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('environment')
        }

        //this.setSunLight()
        // this.setEnvironmentMap()
        // this.setSimpleLight()
        this.setStanzaLight()
    }

    setStanzaLight(){
        this.ambLight= new THREE.AmbientLight('#ffffff',3)
        this.sceneGroup.add(this.ambLight)

        this.pointLightRetro= new THREE.PointLight('#ffffff',3,10)
        this.pointLightRetro.position.set(0,1.5,-4)
        this.sceneGroup.add(this.pointLightRetro)
        // console.log(this.ambLight)
        this.pointLight= new THREE.PointLight('#ffffff',2,10)
        this.pointLight.position.set(-2,1.5,2)
        this.sceneGroup.add(this.pointLight)

        this.pointLight2= new THREE.PointLight('#ffffff',2,10)
        this.pointLight2.position.set(2,1.5,2)
        // this.pointLight.position.set(0,1.5,-4)
        this.sceneGroup.add(this.pointLight2)

        this.pointLightfronte= new THREE.PointLight('#ffffff',2,10)
        this.pointLightfronte.position.set(0,1.5,0.3)
        // this.pointLight.position.set(0,1.5,-4)
        this.sceneGroup.add(this.pointLightfronte)
        // if(this.debug.active)
        // {
        //     // this.debugFolder
        //     //     .add(this.amblight, 'intensity')
        //     //     .name('intensita amb')
        //     //     .min(0)
        //     //     .max(10)
        //     //     .step(0.01),
        //     this.debugFolder
        //         .add(this.pointLight.position, 'x')
        //         .name('pointlight x')
        //         .min(-20)
        //         .max(20)
        //         .step(0.01),
        //     this.debugFolder
        //         .add(this.pointLight.position, 'y')
        //         .name('pointlight y')
        //         .min(-20)
        //         .max(20)
        //         .step(0.01),
        //     this.debugFolder
        //         .add(this.pointLight.position, 'z')
        //         .name('pointlight z')
        //         .min(-20)
        //         .max(20)
        //         .step(0.01)
        // }

    }
    // setSimpleLight(){
    //     this.ambLight= new THREE.AmbientLight('#ffffff',2.9)
    //     this.sceneGroup.add(this.ambLight)

    //     this.pointLight= new THREE.PointLight('#ffffff',10,20)
    //     this.pointLight.position.set(0,2,-1)
    //     this.pointLight.castShadow = true; // default false

    //     //Set up shadow properties for the light
    //     this.pointLight.shadow.mapSize.width = 1024; // default
    //     this.pointLight.shadow.mapSize.height = 1024; // default
    //     this.pointLight.shadow.camera.near = 0.5; // default
    //     this.pointLight.shadow.camera.far = 10; // default
    //     this.pointLight.shadow.normalBias=0.02
    //     this.pointLight.shadow.radius=10
    //     // this.pointLight.shadow.autoUpdate=false

    //     this.sceneGroup.add(this.pointLight)
        
    //     //HELPER LIGHT E SHADOW

    //     // const pointLightHelper = new THREE.PointLightHelper( this.pointLight, 1 );
    //     // this.sceneGroup.add( pointLightHelper );
    //     // const helper = new THREE.CameraHelper( this.pointLight.shadow.camera );
    //     // this.sceneGroup.add( helper );

    //     this.directionalLight = new THREE.DirectionalLight('#ffffff',4.7)

    //     this.directionalLight.position.set(-0.8, 0.8, -3)
    //     this.directionalLight.castShadow=true
    //     this.directionalLight.shadow.camera.far=20
    //     this.directionalLight.shadow.camera.near=-10
    //     this.directionalLight.shadow.mapSize.set(1024,1024)
    //     this.directionalLight.shadow.normalBias=0.02
    //     // this.directionalLight.shadow.radius=50
    //     this.sceneGroup.add(this.directionalLight)
    //     // const helper = new THREE.DirectionalLightHelper( this.directionalLight, 5 );
    //     // this.sceneGroup.add( helper );
    //     // Debug
    //     if(this.debug.active)
    //     {
    //         this.debugFolder
    //             .add(this.ambLight, 'intensity')
    //             .name('ambLightIntensity')
    //             .min(0)
    //             .max(10)
    //             .step(0.001)
            
    //         this.debugFolder
    //         .add(this.pointLight, 'intensity')
    //         .name('point LightIntensity')
    //         .min(0)
    //         .max(10)
    //         .step(0.001)
        
    //         this.debugFolder
    //             .add(this.pointLight.position, 'x')
    //             .name('point LighX')
    //             .min(- 5)
    //             .max(5)
    //             .step(0.001)
    //         this.debugFolder
    //             .add(this.pointLight.position, 'y')
    //             .name('point LightY')
    //             .min(- 5)
    //             .max(5)
    //             .step(0.001)
            
    //         this.debugFolder
    //             .add(this.pointLight.position, 'z')
    //             .name('point LightZ')
    //             .min(- 5)
    //             .max(5)
    //             .step(0.001)
    //         this.debugFolder
    //             .add(this.pointLight, 'castShadow')
    //             .name('point Light shadow')
    //         this.debugFolder
    //             .add(this.directionalLight, 'castShadow')
    //             .name('Sun Light shadow')
    //         }

    // }
    // setSunLight()
    // {
    //     this.sunLight = new THREE.DirectionalLight('#ffffff', 1)
    //     this.sunLight.castShadow = true
    //     this.sunLight.shadow.camera.far = 15
    //     this.sunLight.shadow.mapSize.set(1024, 1024)
    //     this.sunLight.shadow.normalBias = 0.05
    //     this.sunLight.position.set(-1, 1, - 1)
    //     this.sceneGroup.add(this.sunLight)

    //     // Debug
    //     if(this.debug.active)
    //     {
    //         this.debugFolder
    //             .add(this.sunLight, 'intensity')
    //             .name('sunLightIntensity')
    //             .min(0)
    //             .max(10)
    //             .step(0.001)
            
    //         this.debugFolder
    //             .add(this.sunLight.position, 'x')
    //             .name('sunLightX')
    //             .min(- 5)
    //             .max(5)
    //             .step(0.001)
            
    //         this.debugFolder
    //             .add(this.sunLight.position, 'y')
    //             .name('sunLightY')
    //             .min(- 5)
    //             .max(5)
    //             .step(0.001)
            
    //         this.debugFolder
    //             .add(this.sunLight.position, 'z')
    //             .name('sunLightZ')
    //             .min(- 5)
    //             .max(5)
    //             .step(0.001)
    //     }
    // }

    // setEnvironmentMap()
    // {
    //     this.environmentMap = {}
    //     this.environmentMap.intensity = 0.8
    //     this.environmentMap.texture = this.resources.items.envMap
    //     console.log(this.environmentMap.texture)
    //     // this.environmentMap.texture.encoding = THREE.sRGBEncoding
        
    //     // this.sceneGroup.environment = this.environmentMap.texture
    //     // this.sceneGroup.background = this.resources.items.environmentMapTexture
    //     // console.log(this.scene.background)

    //     // this.environmentMap.updateMaterials = () =>
    //     // {
    //     //     this.scene.traverse((child) =>
    //     //     {
    //     //         if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhysicalMaterial)
    //     //         {
    //     //             child.material.envMap = this.environmentMap.texture
    //     //             child.material.envMapIntensity = this.environmentMap.intensity
    //     //             child.material.needsUpdate = true
    //     //         }
    //     //     })
    //     // }
    //     // this.environmentMap.updateMaterials()

    //     // Debug
    //     if(this.debug.active)
    //     {
    //         this.debugFolder
    //             .add(this.environmentMap, 'intensity')
    //             .name('envMapIntensity')
    //             .min(0)
    //             .max(4)
    //             .step(0.001)
    //             .onChange(this.environmentMap.updateMaterials)
    //     }
    // }
}